import React, { useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"

// images flag lang
import flagUs from "../../assets/images/flags/us.jpg"
import flagFrench from "../../assets/images/flags/french.jpg"
import { t } from "i18next"
import { useTranslation } from "react-i18next"

const LanguageDropdown = () => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const { i18n } = useTranslation()

  const changeLanguageAction = lang => {
    //set language as i18n
    i18n.changeLanguage(lang)
  }
  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle className="btn header-item " tag="button">
          <img
            src={i18n.language === "fr" ? flagFrench : flagUs}
            alt="Skote"
            height="16"
            className="me-1"
          />
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          <DropdownItem
            onClick={() => changeLanguageAction("en")}
            className={`notify-item ${
              i18n.language === "en" ? "active" : "none"
            }`}
          >
            <img src={flagUs} alt="Skote" className="me-1" height="12" />
            <span className="align-middle">{t("english")}</span>
          </DropdownItem>
          {/* <DropdownItem
            onClick={() => changeLanguageAction("fr")}
            className={`notify-item ${
              i18n.language === "fr" ? "active" : "none"
            }`}
          >
            <img src={flagFrench} alt="Skote" className="me-1" height="12" />
            <span className="align-middle">{t("french")}</span>
          </DropdownItem> */}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default LanguageDropdown
